export const PROVIDER_PERMISSION_MANAGEMENT_KEYS = {
  PROVIDER_USERS: (providerId: string) => ['provider-users', providerId],
  GET_ALL_ROLES: () => ['provider-users', 'get-all-roles'],
} as const
